module.exports = __webpack_public_path__ + "img/medicine.a31356ae.png";